module.exports = __webpack_public_path__ + "04df96cfae1d340961aa9262a99b4751.pdf";